import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import { Controller, Control } from "react-hook-form";
import {
  CostingMode,
  costingHeaderFieldSx,
  STANDARD_COSTING_MODE,
  SUBCONTRACTED_COSTING_MODE,
  SubcontractorCostingFormValues,
} from "./jobPhaseCosting";

export default function JobCostingHeader({
  control,
  loading,
  today,
  onDateChange,
  onCostingModeChange,
}: {
  control: Control<SubcontractorCostingFormValues>;
  loading: boolean;
  today: string;
  onDateChange: (selectedDate: Date[]) => void;
  onCostingModeChange: (
    newMode: CostingMode,
    onFieldChange: (value: CostingMode) => void
  ) => Promise<void>;
}) {
  return (
    <MDBox
      mb={4}
      p={3}
      sx={{
        border: ({ borders: { borderWidth }, palette: { grey } }: any) =>
          `${borderWidth[1]} solid ${grey[300]}`,
        backgroundColor: ({ palette: { grey } }: any) => grey[100],
      }}
    >
      <Grid container spacing={3} alignItems="flex-end">
        <Grid item xs={12} md={6}>
          <MDTypography variant="h5" mb={1}>
            Date
          </MDTypography>
          <MDDatePicker
            defaultValue={today}
            onChange={onDateChange}
            input={{
              fullWidth: true,
              sx: costingHeaderFieldSx,
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MDTypography variant="h5" mb={1}>
            Costing Mode
          </MDTypography>
          <FormControl fullWidth>
            <Controller
              name="costingMode"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  value={field.value}
                  onChange={async (event) => {
                    const newMode = event.target.value as CostingMode;
                    await onCostingModeChange(newMode, field.onChange);
                  }}
                  disabled={loading}
                  sx={costingHeaderFieldSx}
                >
                  <MenuItem value={STANDARD_COSTING_MODE}>Standard Job Costing</MenuItem>
                  <MenuItem value={SUBCONTRACTED_COSTING_MODE}>
                    Subcontracted Job Costing
                  </MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
    </MDBox>
  );
}
